var EColor;
(function (EColor) {
    EColor["Red"] = "#CC361F";
    EColor["Yellow"] = "#DBDE4B";
    EColor["Orange"] = "#EC7B34";
    EColor["Green"] = "#5FD441";
    EColor["Pink"] = "#DA4FAF";
    EColor["Blue"] = "#4AAAD7";
})(EColor || (EColor = {}));
export { EColor };
